module.exports = __webpack_public_path__ + "static/img/er_code@2x.d52163dd.png";